import { Checkbox, Stack, Text } from "@fluentui/react";
import { BreakpointType } from "../../../../Container/ContainerFluid";
import { useBreakpoint } from "../../../../Container/ContainerStyles";
import { lgTitleStyles, mdTitleStyles, registerMigrationContainerSelectedStyles, registerMigrationContainerStyles, registerMigrationInnerContainerSelectedStyles, registerMigrationTextContainerStyles, smTitleStyles, titleStyles, xlTitleStyles, xxlTitleStyles } from "../Styles/RegisterMigrationsStyles";

export class RegisterMigration {
    selected: boolean = false;
    id: number = 0;
    description: string = "";
}

export interface IRegisterMigrationRowProps {
    checked: boolean;
    title: string;
    onChange: (checked?: boolean) => void;
}

export const RegisterMigrationRow: React.FC<IRegisterMigrationRowProps> = (props) => {
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);

    return (
        <Stack
            grow
            className={props.checked ? registerMigrationContainerSelectedStyles : registerMigrationContainerStyles}
            onClick={() => props.onChange(!props.checked)}
        >
            <Stack
                grow
                horizontal
                horizontalAlign="space-between"
                verticalAlign="center"
                verticalFill
                className={props.checked ? registerMigrationInnerContainerSelectedStyles : undefined}
            >
                <Stack
                    grow
                    horizontal
                    horizontalAlign="start"
                    verticalAlign="center"
                    verticalFill

                    className={registerMigrationTextContainerStyles}
                >
                    <Checkbox
                        checked={props.checked}
                        onChange={() => props.onChange(!props.checked)}
                    />
                    <Stack
                        verticalFill
                        verticalAlign="center"
                    >
                        <Text
                            className={
                                isSM ? 
                                    smTitleStyles : 
                                isMD ? 
                                    mdTitleStyles : 
                                isLG ?
                                    lgTitleStyles :
                                isXL ?
                                    xlTitleStyles :
                                isXXL ?
                                    xxlTitleStyles
                                :
                                    titleStyles
                            }
                        >
                            {props.title}
                        </Text>
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    );
};